import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { LocalidadeUfMunicipioComponent } from './localidade-uf-municipio.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule
    ],
    declarations: [
        LocalidadeUfMunicipioComponent,
    ],
    exports: [
      LocalidadeUfMunicipioComponent,
    ],
})

export class LocalidadeUfMunicipioComponentModule {
}
